import { connect } from "react-redux";
import { Backdrop } from "@material-ui/core";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { FadvSpinner } from "./FadvSpinner";

class LoadingOverlayWrapper extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const bespokeBackdropWrapperClassname = "z-40 relative";
    return (
      <div className="flex flex-col flex-1 min-h-0">
        <div className={bespokeBackdropWrapperClassname}>
          <Backdrop open={this.props.active}>
            <FadvSpinner />
          </Backdrop>
        </div>
        {this.props.children}
      </div>
    )
  }
}


LoadingOverlayWrapper.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.node),
}

const mapStateToProps = state => ({
  active: state.loginForm.isFetching ?? false,
});


export default connect(mapStateToProps)(LoadingOverlayWrapper);